import { Grid2, Paper, Typography } from "@mui/material";
import React from "react";

export default function LeftSection() {
  return (
    <Grid2
      size={{ xs: 12, md: 3 }}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          background: (theme) => theme.palette.primary.main,
          height: "100%",
          paddingY: { xs: 2, md: 4 },
          paddingX: 2,
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#fafafa",
          justifyContent: { xs: "center", md: "start" },
        }}
      >
        <img src="/logo_plain.png" width={"80%"} alt="logo" />
        <Typography variant="h4" mt={{ xs: 2, md: 6 }} textAlign="center">
          Clinic Patient Registration
        </Typography>
        <Typography
          variant="body1"
          mt={4}
          textAlign="left"
          display={{ xs: "none", md: "block" }}
        >
          Fill in the details below to get the patient registered and
          onboarded on EKKO.
        </Typography>
      </Paper>
    </Grid2>
  );
}
